import { Component, Inject, OnDestroy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { BehaviorSubject, ReplaySubject } from 'rxjs';
import { finalize, takeUntil } from 'rxjs/operators';
import { FormControl, Validators } from '@angular/forms';

import { AccountingSettingsService } from 'projects/workspace/src/app/accounting/accounting-settings-module/services';
import { AccountingSettingsModel } from 'projects/workspace/src/app/accounting/accounting-settings-module/models';

@Component({
  selector: 'rnpl-sepa-id-modal',
  templateUrl: './sepa-id-modal.component.html',
})
export class SepaIdModalComponent implements OnDestroy {

  public maskPatterns = {
    N: { pattern: new RegExp('[A-Za-z0-9\\/\\-?:().,\' ]') }
  };
  public sepaIdControl: FormControl = new FormControl(
    null,
    [Validators.required]
  );

  readonly submitRequest$: BehaviorSubject<boolean> = new BehaviorSubject(null);
  readonly destroy$: ReplaySubject<void> = new ReplaySubject(1);

  constructor(
    private readonly accountingSettingsService: AccountingSettingsService,
    public dialogRef: MatDialogRef<SepaIdModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {
      accountingSettings: AccountingSettingsModel;
    }
  ) {
    this.dialogRef.keydownEvents().subscribe(event => {
      if (event.key === 'Escape') {
        this.dialogRef.close();
      }
    });
  }

  public submit(): void {
    this.sepaIdControl.markAsTouched();
    this.sepaIdControl.updateValueAndValidity();

    if (this.sepaIdControl.errors['required']) { return; }
    if (this.submitRequest$.getValue()) { return; }
    this.submitRequest$.next(true);

    const settings: AccountingSettingsModel = {
      ...this.data.accountingSettings,
      sepaId: this.sepaIdControl.value.toUpperCase().trim()
    };

    this.accountingSettingsService.updateAccountingSettings(settings)
      .pipe(
        finalize(() => this.submitRequest$.next(false)),
        takeUntil(this.destroy$)
      )
      .subscribe(() => this.dialogRef.close(true));
  }

  ngOnDestroy(): void {
    this.destroy$.next(null);
    this.destroy$.complete();
  }
}
